// app/store.ts
import { configureStore } from '@reduxjs/toolkit';
import { createUserAutomaticDrawal } from '../service/userAutomaticDrawal/createUserAutomaticDrawal.service';
import { createUserConfigApi } from '../service/userUserConfig/createUserConfig';
import { createUserConfigSendTestApi } from '../service/userUserConfig/createUserConfigSendTest';
import authReducer from '../auth/authSlice'
import { createBlacklistCardApi } from '../service/userCard/createBlacklistCard';
import { blackListCardApi } from '../service/userCard/useBlackListCard';



export const store = configureStore({
  reducer: {
    auth: authReducer,
    [createUserAutomaticDrawal.reducerPath]: createUserAutomaticDrawal.reducer,
    [createUserConfigApi.reducerPath]: createUserConfigApi.reducer,
    [createUserConfigSendTestApi.reducerPath]: createUserConfigSendTestApi.reducer,
    [blackListCardApi.reducerPath]:blackListCardApi.reducer,

  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(createUserAutomaticDrawal.middleware)
      .concat(createUserConfigApi.middleware)
      .concat(createUserConfigSendTestApi.middleware)
      .concat(blackListCardApi.middleware)

});

// Inferir tipos del store
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
